import Vue from "vue";
import axios from "axios";
import qs from "qs";
import router from "@/router/index.js";
import URL from "./api";
import NativeAPI from "../nativeApi/native-api.esm.js";
import { Toast, Dialog } from "vant";
import Until from "../utils/until";

const CancelToken = axios.CancelToken;

// 解码非Latin1字符串（先URL解码，再Base64解码）
export const paramsDecode = str => {
  let base64 = decodeURIComponent(str);
  const binaryString = atob(base64);
  const utf8Bytes = new Uint8Array(
    [...binaryString].map(char => char.charCodeAt(0))
  );
  return JSON.parse(new TextDecoder().decode(utf8Bytes));
};

/**
 *
 * 异步拉起授权
 */
async function getNativeApi(accessId) {
  const data = await NativeAPI.auth.getInsuranceAuth({
    accessId: accessId
  });
  console.log("222", data);
  //用户拒绝授权关闭页面
  if (data.authInfo) {
    localStorage.setItem("authInfo", data.authInfo);
  } else {
    NativeAPI.appOperate.openPage({ pageName: "buyCarList", popToRoot: "1" });
  }
}

//异步获取状态栏高度
async function getStatusBarHeight() {
  const data = await NativeAPI.appInfo.getStatusBarHeight();
  if (Until.isAndroid() || Until.isHarmony()) {
    document.documentElement.style.setProperty(
      "--statusHeight",
      calc(
        (Number(data.statusBarHeight) / Number(data.screenHeight)) * 100 +
          "%" +
          "44px"
      )
    );
    console.log(
      (Number(data.statusBarHeight) / Number(data.screenHeight)) * 100 + "%"
    );
  } else {
    updataHeight(data.statusBarHeight);
  }
}
function updataHeight(statusHeight) {
  document.documentElement.style.setProperty(
    "--statusHeight",
    Number(statusHeight ? statusHeight : 40) + 44 + "px"
  );
  console.log((statusHeight ? statusHeight : 40) + 44 + "px");
}

/**
 * 判断是否H5进入
 * @returns Boolean
 */

export function isH5Flag() {
  let location_url = location.href.split("?")[1];
  const urlQs = qs.parse(location_url); // 获取地址url
  //判断来源是否有H5字段
  if(urlQs.operation == 'h5') {
      //更新验证
      //设置h5标识
      localStorage.setItem("operation", "h5");
      return true
  }else {
      // 清空标识
      localStorage.removeItem("operation");
      return false
  }
}

/**
 * 获取token接口
 */
export async function postAuthorize() {
  let location_url = location.href.split("?")[1];
  let isDetails = location.href.includes("details");
  let isCarmessage = location.href.includes("carmessage");

  const urlQs = qs.parse(location_url);

  if (urlQs.test) {
    localStorage.setItem("test", urlQs.test);
    localStorage.setItem("energyType", urlQs.energyType);
    localStorage.setItem("invoiceAmount", urlQs.invoiceAmount);
    // return;
  }

  console.log(location_url);
  console.log(urlQs);
  //   if (!urlQs.params) {
  //     Dialog({
  //       message: "访问权限受限!"
  //     });
  //     router.replace("/404");
  //     return;
  //   }
  if (isDetails || isCarmessage) {
    let cshParmas = paramsDecode(urlQs.params);
    localStorage.setItem("cshParmas", JSON.stringify(cshParmas));

    console.log(JSON.stringify(cshParmas));
    return await axios
      .post(URL.getParams, { authToken: cshParmas.authToken })
      .then(res => {
        if (res.data.status == 0) {
          console.log(res.data.data, "666");
          localStorage.setItem("params", JSON.stringify(res.data.data));
          //初始化
          NativeAPI.config({
            timeout: 5000, // 超时时间, 单位毫秒
            debug: true, // 开发/测试环境 设置为true,  生产环境设置为 false
            jsApiToken: res.data.data.jsApiToken // jsBridge Api调用合法性校验token, 来源: 车企或保司根据私钥对authToken 进行解密, 可以得到 jsApiToken
          });
          getStatusBarHeight();
          console.log(isDetails);
          //是否详情跳转
          if (isDetails) {
            //直接跳转详
            localStorage.setItem(
              "userId",
              JSON.parse(localStorage.getItem("params")).userId
            );
            localStorage.setItem(
              "orderNo",
              JSON.parse(localStorage.getItem("params")).pjddbh
            );
            return;
          } else if (isCarmessage) {
            NativeAPI.appOperate.setNativeBackDisableState({ disable: "1" });
            // getNativeApi(cshParmas.accessId);
          }
        } else {
          Toast({
            duration: 2000,
            message: res.data.data.msg
          });
        }
      })
      .catch(e => {
        Toast({
          duration: 2000,
          message: e.response.data.msg
        });
      });
    x;
  }
}

//对post请求统一加参数
export const reqPosCancel = (url, parms) => {
  // parmsFn(parms);
  let config = {};
  config = Object.assign(config, parms);

  return axios
    .post(url, config, { cancelToken: new CancelToken(function(params) {}) })
    .then(res => {
      return res.data;
    })
    .catch(e => {
      if (/Network/gi.test(e)) {
        // Vue.prototype.$alert('请求出错，请检查网络是否断开连接或者刷新页面试试！', '提示信息', {
        //   confirmButtonText: '确定',
        //   callback: action => {
        //     if (action == 'confirm')
        //     }
        //   }
        // });
        return;
      }
      if (e.response && e.response.data.status == "500") {
        Vue.prototype.$message({
          duration: 1500,
          showClose: true,
          message: "服务器出错",
          type: "error",
          onClose: () => {}
        });
      }
      if (e.response && e.response.data.status == "401") {
        Vue.prototype.$message({
          duration: 1500,
          showClose: true,
          message: e.response.data.msg,
          type: "error",
          onClose: () => {
            //token失效 后续处理
          }
        });
        return;
      } else {
        return e;
        // console.log("ooooo", "网络请求出错！！")
      }
    });
};

//对post请求统一加参数
export const reqPos = (url, parms) => {
  // parmsFn(parms);
  let config = {};
  config = Object.assign(config, parms);

  return axios
    .post(url, config)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      if (/Network/gi.test(e)) {
        // Vue.prototype.$alert('请求出错，请检查网络是否断开连接或者刷新页面试试！', '提示信息', {
        //   confirmButtonText: '确定',
        //   callback: action => {
        //     if (action == 'confirm')
        //     }
        //   }
        // });
        return;
      }
      if (e.response && e.response.data.status == "500") {
        Vue.prototype.$message({
          duration: 1500,
          showClose: true,
          message: "服务器出错",
          type: "error",
          onClose: () => {}
        });
      }
      if (e.response && e.response.data.status == "401") {
        Vue.prototype.$message({
          duration: 1500,
          showClose: true,
          message: e.response.data.msg,
          type: "error",
          onClose: () => {
            //token失效 后续处理
          }
        });
        this.$router.push({
          path: "/login"
        });
        return;
      } else {
        return e;
        // console.log("ooooo", "网络请求出错！！")
      }
    });
};

//对get请求预备参数
export const reqGet = (url, parms) => {
  let config = {};
  config = Object.assign(config, parms);
  return axios
    .get(url, {
      params: config
    })
    .then(res => {
      return res.data;
    })
    .catch(e => {
      if (/Network/gi.test(e)) {
        // Vue.prototype.$alert('请求出错，请检查网络是否断开连接或者刷新页面试试！', '提示信息', {
        //   confirmButtonText: '确定',
        //   callback: action => {
        //     if (action == 'confirm') {

        //     }
        //   }
        // });
        // Loading.service().close();

        return;
      }
      if (e.response && e.response.status == "401") {
        Vue.prototype.$message({
          duration: 1500,
          showClose: true,
          message: e.response.data.msg,
          type: "error",
          onClose: () => {}
        });
        // location.href = `//${location.host}/#/login`;

        return;
      }
      return e;
    });
};

//对postformdata请求统一加参数
export const reqPosFor = (url, parms) => {
  let formdata = new FormData();
  for (const key in parms) {
    if (parms.hasOwnProperty(key)) {
      const element = parms[key];
      formdata.append(key, element);
    }
  }
  // formdata.append('images', parms.images);
  // formdata.append('imageType', parms.imageType);
  // formdata.append('orderNo', sessionStorage.getItem('orderNo') || "");
  return axios
    .post(url, formdata)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      if (/Network/gi.test(e)) {
        // Vue.prototype.$alert('请求出错，请检查网络是否断开连接或者刷新页面试试！', '提示信息', {
        //   confirmButtonText: '确定',
        //   callback: action => {
        //     if (action == 'confirm') {

        //     }
        //   }
        // });
        // Loading.service().close();
        return;
      }
      if (e.response && e.response.status == "401") {
        console.log("ss");
        Vue.prototype.$message({
          duration: 1500,
          showClose: true,
          message: e.response.data.msg,
          type: "error"
        });
        return;
      } else {
        return e;
      }
    });
};
//对postformdata请求统一加参数
export const reqPosFor2 = (url, parms) => {
  // console.log("parms",parms,new FormData())
  let formdata = new FormData();
  formdata.append("sequenceId", parms.sequenceId || "''");
  if (!!parms.images) {
    formdata.append("images", parms.images || "");
  }
  if (!!parms.imageType) {
    formdata.append("imageType", parms.imageType || "");
  }
  if (!!parms.file) {
    formdata.append("file", parms.file || "");
  }
  let contentType = {
    headers: {
      // 'PartnerCode': "p_unkmotor",
      "Content-type": "multipart/form-data"
    }
  };
  axios.defaults.headers.common["sysVersion"] =
    localStorage.getItem("gsSysVersion") || "V2";
  return axios
    .post(url, formdata, contentType)
    .then(res => {
      // store.state.showLoading = false;
      return res.data;
    })
    .catch(e => {});
};



// WEBPACK FOOTER //
// ./src/request/http.js